import { theme } from '@carto/react-ui';

const customTheme = {
  ...theme,
  palette: {
    ...theme.palette,
    primary: {
      ...theme.palette.primary,
      main: '#1B51E5',
      light: '#EFF2FE',
      dark: '#3818bb',
    },
  },
};

export default customTheme;
